<template>
  <div class="page">
    <a-spin tip="Loading..." :spinning="spinning">
      <!-- 顶部月份 -->
      <div class="toolbar">
        <view @click="changeMonth(-1)"> <CaretLeftOutlined /> </view>

        <div class="month-title">{{ currentYear }}年{{ currentMonth }}月</div>

        <view @click="changeMonth(1)"> <CaretRightOutlined /> </view>
        <div class="reselve" @click="GetOverTimeList()">
          <CloudSyncOutlined :style="{ fontSize: '30px', color: '#52c41a' }" />
        </div>
        <div class="exit" @click="exitClick()">
          <PoweroffOutlined :style="{ fontSize: '22px', color: '#eb2f96' }" />
        </div>
      </div>

      <!-- 表格 -->
      <div
        class="calendar"
        :style="{
          '--days': days.length,
        }"
      >
        <!-- 左上角 -->
        <div class="header user-header">工程师</div>

        <!-- 日期头 -->
        <template v-for="(day, index) in days" :key="day">
          <div
            class="header day-header"
            :class="{
              weekend: isWeekend(day),
              today: isToday(day),
            }"
          >
            <div>{{ day }}</div>
            <div class="header_date">
              {{ getWeekday(currentYear + "-" + currentMonth + "-" + day) }}
            </div>
          </div>
        </template>

        <!-- 总数 -->
        <div class="header count-header">加班天数</div>

        <!-- 用户行 -->
        <template v-for="(user, rowIndex) in users" :key="user.id">
          <!-- 用户名 -->
          <div class="user-cell">
            {{ user.name }}
          </div>

          <!-- 日期格 -->
          <template v-for="(day, colIndex) in days" :key="day">
            <div
              class="cell"
              :class="cellClass(user.id, day, rowIndex, colIndex)"
              @mouseenter="
                hoverRow = rowIndex;
                hoverCol = colIndex;
              "
              @mouseleave="
                hoverRow = -1;
                hoverCol = -1;
              "
              @click="handleClick(user.id, day)"
            />
          </template>

          <!-- 总数 -->
          <div class="count-cell">
            {{ getUserCount(user.id) }}
          </div>
        </template>
      </div>
    </a-spin>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, createVNode } from "vue";
import { message, Modal } from "ant-design-vue";
import { useRouter } from "vue-router";
import axios from "axios";
import {
  CaretLeftOutlined,
  CaretRightOutlined,
  RedoOutlined,
  CloudSyncOutlined,
  PoweroffOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";

onMounted(() => {
  currentUserId.value = localStorage.getItem("kpiUserId");
  GetUserList();
});

const router = useRouter();
const currentUserId = ref("1003");
const spinning = ref(false);

//获取人员列表
function GetUserList() {
  spinning.value = true;
  axios
    .post("https://camapi.bodor.com:8088/api/OT/GetUserList", {})
    .then((response) => {
      spinning.value = false;
      let datat = response.data;
      if (datat.code == 200 && datat.ReturnType) {
        users.value = datat.ReturnData.map((item) => ({
          id: item.Id,
          name: item.RealName,
        }));
        //获取加班数据
        GetOverTimeList();
      } else {
        users.value = [];
      }
    })
    .catch((err) => {
      spinning.value = false;
    });
}

//获取加班数据
function GetOverTimeList() {
  spinning.value = true;
  let params = {
    StartDate:
      currentYear.value +
      "-" +
      currentMonth.value.toString().replace(/^(\d)$/, "0$1") +
      "-01 00:00:00",
    EndDate:
      currentYear.value +
      "-" +
      currentMonth.value.toString().replace(/^(\d)$/, "0$1") +
      "-" +
      days.value.length.toString().replace(/^(\d)$/, "0$1") +
      " 23:59:59",
  };
  axios
    .post("https://camapi.bodor.com:8088/api/OT/GetOverTimeList", params)
    .then((response) => {
      spinning.value = false;
      let datat = response.data;
      if (datat.code == 200 && datat.ReturnType) {
        records.value = datat.ReturnData.map((item) => ({
          userId: item.UserId,
          workDate: item.WorkDate,
        }));
      } else {
      }
    })
    .catch((err) => {
      spinning.value = false;
    });
}

//点击退出
function exitClick() {
  Modal.confirm({
    title: () => "提示?",
    icon: () => createVNode(ExclamationCircleOutlined),
    content: () => "是否要退出登录",
    okText: () => "退出",
    okType: "danger",
    cancelText: () => "取消",
    onOk() {
      localStorage.removeItem("token");
      localStorage.removeItem("kpiUserId");
      router.push("/kpi");
    },
    onCancel() {},
  });
}

const users = ref([
  { id: "1001", name: "胡晓鹍" },
  { id: "1002", name: "葛红红" },
  { id: "1003", name: "李晓屯" },
  { id: "1004", name: "刘彦伟" },
  { id: "1005", name: "王占涛" },
  { id: "1006", name: "杨庆雨" },
  { id: "1007", name: "田敏" },
  { id: "1008", name: "王玉康" },
  { id: "1009", name: "宋西平" },
  { id: "1010", name: "李宗瑶" },
  { id: "1011", name: "郑朝阳" },
  { id: "1012", name: "屈会聪" },
  { id: "1013", name: "张义松" },
  { id: "1014", name: "高廷广" },
  { id: "1015", name: "李帅" },
  { id: "1016", name: "尹棋正" },
  { id: "1017", name: "徐靖" },
  { id: "1018", name: "庄铭" },
  { id: "1019", name: "陈旭" },
  { id: "1020", name: "李伟" },
  { id: "1021", name: "周逸飞" },
  { id: "1022", name: "宋占伟" },
]);

const currentDate = ref(new Date());

const hoverRow = ref(-1);
const hoverCol = ref(-1);

const records = ref([]);

const currentYear = computed(() => {
  return currentDate.value.getFullYear();
});

const currentMonth = computed(() => {
  return currentDate.value.getMonth() + 1;
});

const days = computed(() => {
  const count = new Date(currentYear.value, currentMonth.value, 0).getDate();

  return Array.from({ length: count }, (_, i) => i + 1);
});

function changeMonth(step) {
  const date = new Date(currentDate.value);

  date.setMonth(date.getMonth() + step);

  currentDate.value = date;
  //获取加班数据
  GetOverTimeList();
}

function getDateString(day) {
  return `${currentYear.value}-${String(currentMonth.value).padStart(2, "0")}-${String(
    day
  ).padStart(2, "0")}`;
}

function isToday(day) {
  const now = new Date();

  return (
    now.getFullYear() === currentYear.value &&
    now.getMonth() + 1 === currentMonth.value &&
    now.getDate() === day
  );
}

function isWeekend(day) {
  const week = new Date(currentYear.value, currentMonth.value - 1, day).getDay();

  return week === 0 || week === 6;
}

function isActive(userId, day) {
  const date = getDateString(day);
  return records.value.some((item) => item.userId === userId && item.workDate === date);
}

function canClick(userId, day) {
  if (userId !== currentUserId.value) {
    return false;
  }

  const now = new Date();

  if (
    currentYear.value !== now.getFullYear() ||
    currentMonth.value !== now.getMonth() + 1
  ) {
    return false;
  }

  const today = now.getDate();

  return day === today || day === today + 1;
}

function handleClick(userId, day) {
  if (!canClick(userId, day)) {
    return;
  }

  const date = getDateString(day);

  const index = records.value.findIndex(
    (item) => item.userId === userId && item.workDate === date
  );

  if (index > -1) {
    //取消预约
    records.value.splice(index, 1);
    let params = {
      UserId: userId,
      WorkDate: date,
    };
    //保存加班
    SaveOverTime(params, "取消成功");
  } else {
    //预约
    records.value.push({
      userId,
      workDate: date,
    });
    let params = {
      UserId: userId,
      WorkDate: date,
    };
    //保存加班
    SaveOverTime(params, "预约成功");
  }

  saveData();
}

//保存加班
function SaveOverTime(params, str) {
  spinning.value = true;
  axios
    .post("https://camapi.bodor.com:8088/api/OT/SaveOverTime", params)
    .then((response) => {
      spinning.value = false;
      let datat = response.data;
      if (datat.code == 200 && datat.ReturnType) {
        message.success(str);
        //获取加班数据
        GetOverTimeList();
      } else {
        message.error(datat.info);
      }
    })
    .catch((err) => {
      spinning.value = false;
    });
}

function cellClass(userId, day, row, col) {
  return {
    active: isActive(userId, day),

    rowHover: hoverRow.value === row,

    colHover: hoverCol.value === col,

    disabled: !canClick(userId, day),
  };
}

function getUserCount(userId) {
  return records.value.filter((item) => item.userId === userId).length;
}

async function saveData() {
  // 调接口保存
}

function getWeekday(dateStr) {
  const date = new Date(dateStr);
  const weekdays = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
  return weekdays[date.getDay()];
}
</script>

<style scoped lang="scss">
.page {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #fff;
}

.toolbar {
  height: 60px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  border-bottom: 1px solid #eee;
  position: relative;
  view {
    cursor: pointer;
  }
  .reselve {
    position: absolute;
    right: 100px;
    top: 15px;
    cursor: pointer;
  }
  .exit {
    position: absolute;
    left: 100px;
    top: 15px;
    cursor: pointer;
  }
}

.month-title {
  font-size: 16px;
}

.calendar {
  height: calc(100vh - 60px);

  display: grid;

  grid-template-columns:
    140px
    repeat(var(--days), 1fr)
    100px;

  grid-auto-rows: minmax(36px, 1fr);
}

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  font-size: 14px;
  font-weight: 600;

  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;

  background: #fafafa;

  position: sticky;
  top: 0;
  z-index: 20;
}

.user-header {
  left: 0;
  z-index: 30;
}

.user-cell {
  display: flex;
  align-items: center;
  justify-content: center;

  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;

  background: #fff;

  position: sticky;
  left: 0;
  z-index: 10;
}

.day-header.today {
  background: #d9ecff;
}

.day-header.weekend {
  background: #faf6eb;
}
.header_date {
  font-size: 11px;
}

.count-header {
  position: sticky;
  right: 0;
}

.count-cell {
  display: flex;
  align-items: center;
  justify-content: center;

  border-left: 1px solid #eee;
  border-bottom: 1px solid #eee;

  position: sticky;
  right: 0;

  background: #fff;
}

.cell {
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;

  cursor: pointer;

  transition: 0.2s;
}

.cell.rowHover {
  background: rgba(64, 158, 255, 0.06);
}

.cell.colHover {
  background: rgba(64, 158, 255, 0.06);
}

.cell.active {
  background: linear-gradient(135deg, #409eff, #66b1ff);
}

.cell.disabled {
  cursor: not-allowed;
}

.cell.active.rowHover,
.cell.active.colHover {
  background: linear-gradient(135deg, #337ecc, #5aa5ff);
}
</style>
